<style lang="less" scoped>
.category {position: relative;width: 350px;text-align: left;font-family: AlibabaPuHuiTi-Regular;font-size: 16px;letter-spacing: 1px;}
ul {list-style: none;width: 350px;}
li {width: 160px;float: left;margin-bottom: 28px;margin-right: 12px;}
li:hover {color: #13569e;cursor: pointer;}
.count{font-size: 12px;opacity: .6;}
</style>

<!-- 何宽 2021.6.10
     该组件使用场景：将内容分为几个不同的大类，以标题加数量的形式进行展示。点击标题， 将 相应的对象 传递给父组件 -->
<template>
  <div class="category">
    <ul>
      <li v-for="(item,index) in categoryList" :key="index" @click="clickCategory(item)">
        <span class="title">{{ item.type }}</span><span class="count">({{ item.count }})</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['categoryList'],
  data()
  {
    return {}
  },
  methods:
  {
    // 点击分类选项，将 选中的对象 传递给父组件
    clickCategory(item)
    {
      this.$emit('clickCategory', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Category.vue